import type { ProductListing } from "../types/generated-graphql";
import Env from "../utils/env";
import { ProductListingTypes } from "./product";

export interface ProductRouteParams {
	productId: string;
	tabid?: string;
}

export enum TabIDs {
	Overview = "overview",
	ProductInformation = "product-information",
	Components = "components",
	Support = "support",
	CertificationsAndValidations = "validations-and-certifications",
}

interface RouteList {
	text: string;
	path: string;
	id: TabIDs;
	routeMatch: string;
	exact: boolean;
}

export const getProductDetailsRouteList = (
	productId: string,
	productDetail: Omit<ProductListing, "edges"> | undefined,
): RouteList[] => {
	let routeList: RouteList[] = [
		{
			text: `Overview`,
			path: `${Env.routePrefix}${Env.productDetailsPrefix}/${productId}/overview`,
			id: TabIDs.Overview,
			routeMatch: `/manage/products/:productId/overview`,
			exact: true,
		},
		{
			text: `Product information`,
			path: `${Env.routePrefix}${Env.productDetailsPrefix}/${productId}/product-information/general`,
			id: TabIDs.ProductInformation,
			routeMatch: `/manage/products/:productId/product-information`,
			exact: false,
		},
		{
			text: `Components`,
			path: `${Env.routePrefix}${Env.productDetailsPrefix}/${productId}/components`,
			id: TabIDs.Components,
			routeMatch: `/manage/products/:productId/components`,
			exact: true,
		},
		{
			text: `Support`,
			path: `${Env.routePrefix}${Env.productDetailsPrefix}/${productId}/support`,
			id: TabIDs.Support,
			routeMatch: `/manage/products/:productId/support`,
			exact: true,
		},
	];

	if (
		productDetail?.type === ProductListingTypes.ContainerStack ||
		productDetail?.type === ProductListingTypes.TraditionalApplication
	) {
		const index = 2;
		routeList = [
			...routeList.slice(0, index),
			{
				text: `Validations & Certifications`,
				path: `${Env.routePrefix}${Env.productDetailsPrefix}/${productId}/validations-and-certifications/support-statement`,
				id: TabIDs.CertificationsAndValidations,
				routeMatch: `/manage/products/:productId/validations-and-certifications/:tabid?`,
				exact: false,
			},
			...routeList.slice(index),
		];
	}
	return routeList;
};
